import { IS_ADMIN } from './validation';

const serviceProvider = window.$environment?.SERVICE_PROVIDER;
const appLayout = window.$environment.CURRENT_LAYOUT;

const showSVGEdit = () => window.$environment.SERVICE_PROVIDER == 'nauto' || window.$environment.SERVICE_PROVIDER == 'radius';

export const mediaUrls = {
  //new changes start

  // all SVG's

  // viewArrow: 'viewArrow.svg', // need to check
  // dtc: 'dtc.svg', // need to check
  // locationMap: 'locationMap.svg',  // need to check
  // direction: 'direction.svg',  // need to check
  // speedometer: 'speedometer.svg', // need to check
  // viewAllMap: 'viewallMap.svg',
  // inspection: 'inspection.svg',  // need to check
  // delete: 'deleteCircle.svg',
  // departmentTool: 'tools.svg',
  // downloadIcon: 'download.svg',
  // updateIcon: 'update.svg',
  // loginAs: 'new_login.svg',  // need to check
  // menu_reseller: 'menu_reseller.svg',
  // cameraIcon: 'cameraSelected.svg',
  // historyPdficon: 'file-pdf-regular.svg',  // need to check
  // logbookIcon: 'book-solid.svg',  // need to check
  // saveUdlog: 'save-regular.svg',  // need to check
  // menu_users: 'user.svg',
  // menu_vehicle: 'menu_vehicle.svg',  // need to check
  // menu_dailyLogs: 'menu_dailyLog.svg',  // need to check
  // companyIcon: 'companyIcon.svg',  // need to check
  // companyList: 'company.svg',  // need to check
  // closedWorkOrder: 'Closed.svg',  // need to check
  // notstartedorangeIcons: 'not_started_orange.svg',
  // awaitingorangeIcons: 'awaiting_parts_orange.svg',
  // progressorangeIcons: 'in_progress_orange.svg',
  // completeorangeIcons: 'complete-Orange.svg',
  // closedOrangeIcons: 'closed-Orange.svg',
  // exportAllCircle: 'circle-Exportall_grey.svg',  // need to check

  excel: 'Excel.svg',
  leftArrow: 'leftArrow.svg',
  arrowRight: 'arrowRight.svg',
  viewDocument: 'viewDocument.svg',
  historyLogs: 'historyLogs.svg',
  logEdit: 'departmetEdit.svg',
  download: 'download.svg',
  share: 'share.svg',
  address: 'address.svg',
  phone: 'phone.svg',
  mail: 'mail.svg',
  downarrowIcon: 'downarrowIcon.svg',
  user: 'user.svg',
  vehicle: 'vehicle.svg',
  logsIcon: 'logsIcon.svg',
  arrowdownIcon: 'arrow-down.svg',
  pageBackButton: 'back-btn.svg',
  editSvg: 'editSvg.svg',
  driverbehavior: 'driver-behaviour.svg',
  vehicleBehaviour: 'vehicle-behaviour.svg',
  filePdfRegular: 'file-pdf-regular.svg',
  bookSolid: 'book-solid.svg',
  bobTail: 'bobTail.svg',
  saveRegular: 'save-regular.svg',
  confirmIcon: 'popupConfirm.svg',
  inspections: 'inspection.svg',
  companies: 'companyIcon.svg',
  dashboardIcon: 'dashboardIcon.svg',
  userIcon: 'users.svg',
  reportsIcon: 'reportIcon.svg',
  departments: 'departments.svg',
  company: 'company.svg',
  dotAuditIcon: 'dotauditIcon.svg',
  supportIcon: 'supportIcon.svg',
  oldView: 'switch.svg',
  inspection_dvir: 'inspection-dvir.svg',
  vehiclesIcon: 'vehicleIcon.svg',
  accident: 'accident.svg',
  fleetCompanies: 'fleetCompanies.svg',
  upcomingRenewal: 'renewal.svg',
  fleetDriver: 'fleetdriverIcon.svg',
  fleetVehicle: 'fleetvehiclesIcon.svg',
  helpIcon: 'help-icon.svg',
  searchIcon: 'searchGrey.svg',
  addOrange: 'addOrange.svg',
  deletePopup: 'popupDelete.svg',
  new_export: 'export.svg',
  new_export_circle: 'circle-export.svg',
  closeIcon: 'close-popup.svg',
  unsort: 'sort.svg',
  notFull: 'notFull.svg',
  deleteIcon: 'deleteCircle.svg',
  logout: 'logoutIcon.svg',
  viewMoreIcon: 'viewallMap.svg',
  full: 'full.svg',
  viewReports: 'viewReports.svg',
  viewPicture: 'View_Pic_Grey.svg',
  tickIcon: 'tick.svg',
  addVehicle: 'addVehicle.svg',
  uploadIcon: 'upload.svg',
  toggleOn: 'toggle-on.svg',
  toggleOff: 'toggle-off.svg',
  refreshIcon: 'update.svg',
  clearAll: 'clearAll.svg',
  editDepartment: 'departmetEdit.svg',
  downloadCenter: 'downloadCenter.svg',
  undelete: 'undelete.svg',
  scoreCard: 'scoreCard.svg',
  toolsIcon: 'tools.svg',
  logHistory: 'logHistory.svg',
  viewStatus: 'viewStatus.svg',
  menu_companies: 'menu_companies.svg',
  key: 'key.svg',
  logs: 'logs.svg',
  repair: 'repair.svg',
  account: 'account.svg',
  language: 'es.svg',
  languageEn: 'en.svg',
  messaging: 'messaging.svg',
  whiteCheck: 'whitecheck_new.svg',
  calanderIcon: 'calanderIcon.svg',
  timePicker: 'timePicker.svg',
  importUser: 'importUser.svg',
  importUserCircle: 'circle-importUser.svg',
  import: 'import.svg',
  importCircle: 'circle-import.svg',
  selectedConnection: 'selectedConnection.svg',
  notstartedIcons: 'not_started_grey.svg',
  progressgreyIcons: 'in_progress_grey.svg',
  awaitinggreyIcons: 'awaiting_parts_grey.svg',
  completegreyIcons: 'complete-grey.svg',
  closedgreyIcons: 'closed-grey.svg',
  ninePin: 'ninePin.svg',
  sixPin: 'sixPin.svg',
  dualCam: 'dualCam.svg',
  obdii: 'qbdii.svg',
  mack: 'mack.svg',
  volvo: 'volvo.svg',
  infoTruck: 'infoTruck.svg',
  van: 'van.svg',
  dump: 'dump.svg',
  pickup: 'pickup.svg',
  flatBed: 'flatBed.svg',
  dryVan: 'dryVan.svg',
  reeferTrailer: 'reeferTrailer.svg',
  boxTruck: 'boxTruck.svg',
  vacuumTrailer: 'vacuumTrailer.svg',
  tankerTrailer: 'tankerTrailer.svg',
  otherTrailer: 'otherTrailer.svg',
  pneumaticTrailer: 'pneumaticTrailer.svg',
  straightTruck: 'straightTruck.svg',
  tractorDayCab: 'tractorDayCab.svg',
  tractorSleeper: 'tractorSleeper.svg',
  privatePassenger: 'privatePassenger.svg',
  importUserTemplate: 'excelNew.svg',
  backButton: 'backButton.svg',
  sendMsg: 'messageSender.svg',
  hamburger: 'hamburger.svg',
  chatIcon: 'chat-icon.svg',
  downloadCenterMenu: 'downloadCenterMenu.svg',
  dailyDocuments: 'dailyDocuments.svg',
  fuel: 'fuel.svg',
  policy: 'policy.svg',
  dashboard: 'dashboard.svg',
  feedback: 'feedback.svg',
  filter: 'filter.svg',
  usdot: 'usdot.svg',
  document: 'document.svg',
  ifta: 'ifta.svg',
  developer: 'developer.svg',
  csa: 'csa.svg',
  menu_resellers: 'menu_reseller.svg',
  reports: 'reports.svg',
  camera: 'cameraSelected.svg',
  exportAll: 'Exportall_grey.svg',
  exportAllCircle: 'Exportall_grey_circle.svg',
  exportUser: 'exportUser.svg',
  exportUserCircle: 'circle-exportUser.svg',
  closeWhit: 'closeMap.svg',
  viewAll: 'circle-viewall.svg',
  refreshCircle: 'refreshCircle.svg',
  overview: 'overview.svg', // icon: 'overview'
  alerts: 'alert.svg', // icon: 'alerts'
  driverStatus: 'driver.svg', // icon: 'driverStatus'
  violation: 'violation.svg', // icon: 'violation'
  csaSnapshot: 'csaSnapshot.svg', // icon: 'csaSnapshot'
  pageFirst: 'page-first.svg',
  pageLast: 'page-last.svg',
  pagePrev: 'page-prev.svg',
  pageNext: 'page-next.svg',
  edit: showSVGEdit() ? 'departmetEdit.svg' : 'editSvg.svg',

  // tenant based images
  innerLogo: 'innerLogo.png',
  logo: 'logo.webp',
  bg_image: 'bg_log.webp',
  clutchLogin: 'clutchLogin.webp',
  clutchLogo: 'clutch_logo.png',
  poweredBy: 'gorilla_poweredby.png',
  loginbg: 'login-bg.webp',
  mapCluster: 'clusterIcon.png',

  // gif media
  ajaxLoader_es: 'ajax-Loader_es.gif',
  ajaxLoader: 'ajax-Loader.gif',
  chatLoader: 'chatLoader.gif',
  checkedBackground: 'checkedBackground.gif',
  uncheckedBackground: 'uncheckedBackground.gif',

  // common images
  smallLogo: 'smallLogo.png',
  appStore: 'appstore.png',
  googleplay: 'googleplay.png',
  logedIcon: 'logedIcon.png',
  logo_mobile: 'logo_mobile.png',
  onBoarding: 'onBoarding.webp',
  eldIcon: 'eldIcon.jpg',
  spotlightGreen: 'spotlightGreen.png',
  spotlightGrey: 'spotlightGrey.png',
  spotlightRed: 'spotlightRed.png',

  // new changes end
};

export const getMediaSource = (file) => {
  const media = require.context('globalassets/media', true);
  try {
    const image = media(`./${process.env.REACT_APP_BUILD}/${serviceProvider}/${appLayout}/${file}`);
    return image;
  } catch (error) {
    const image = media(`./${process.env.REACT_APP_BUILD}/${serviceProvider}/${file}`);
    return image;
  }
};

export const getMediaPath = (file, isS3 = false) => {
  if (window.$environment.SERVICE_PROVIDER == 'eldx' && !IS_ADMIN && isS3)
    return `${window.$environment.S3_URL}/${JSON.parse(sessionStorage.getItem('reseller_data'))?.logo}`;

  if (file) {
    try {
      try {
        const image = getMediaSource(file);
        return image;
      } catch (error) {
        const media = require.context('globalassets/media/common', true);
        const image = media(`./${file}`);
        return image;
      }
    } catch (error) {
      return null;
    }
  }
  return null;
};

export const getSvgPath = (file) => {
  const media = require.context('globalassets/svgs', true);
  if (file) {
    try {
      const image = media(`./${file}`);
      return image;
    } catch (error) {
      return null;
    }
  }
  return null;
};
